import { auth, provider } from '../configs/firebaseConfig';
import { Google as GoogleIcon } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
  useTheme,
  alpha
} from '@mui/material';
import { signInWithPopup } from 'firebase/auth';
import { useState } from 'react';

const Login = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();

  const handleSubmit = async () => {
    setIsLoading(true);
    setErrorMessage('');
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.main, 0.1)} 100%)`,
        p: 2
      }}
    >
      <Container maxWidth="xs">
        <Card
          elevation={0}
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 3,
            overflow: 'hidden'
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              py: 4,
              px: 3,
              textAlign: 'center'
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: theme.palette.primary.contrastText,
                fontWeight: 700,
                mb: 1
              }}
            >
              H2O Admin
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: alpha(theme.palette.primary.contrastText, 0.8)
              }}
            >
              Sign in to manage your business
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
              startIcon={<GoogleIcon />}
              sx={{
                py: 1.5,
                fontSize: '1rem',
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: theme.shadows[4]
                }
              }}
            >
              {isLoading ? 'Signing in...' : 'Sign in with Google'}
            </Button>

            {errorMessage && (
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.error.main, 0.08),
                  border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.error.main,
                    textAlign: 'center'
                  }}
                >
                  {errorMessage}
                </Typography>
              </Box>
            )}

            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                display: 'block',
                textAlign: 'center',
                mt: 3
              }}
            >
              By signing in, you agree to our Terms of Service
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default Login;
